<template>
  <div class="VideoIndex">
    <!-- Container -->
    <div
      class="container"
      v-loading="floading"
      element-loading-background="transparent"
    >
      <!-- 編輯精選 -->
      <section id="featured-video" v-if="videodataFeatured.length > 0">
        <h2 class="section-title"> {{ $t('Video.VideoIndex.EditorChoice') }}</h2>
        <div class="ddd">
          <div class="section-group">
            <div class="video-row row" style="margin-left: 0px">
              <div
                class="video-card card"
                v-for="Featured in videodataFeatured"
                v-bind:key="Featured.id"
                v-on:click="videoCardClick(Featured.sgL_Mov_Vid)"
              >
                <div class="video-block">
                  <div class="video-thumbnail">
                    <!-- <router-link
                    v-bind:to="{name:'WatchVideo',params:{id:Featured.sgL_Mov_Vid,itemtype:'video'}}"
                  >-->
                    <a
                      :href="`${base.evi}/videowatch/${Featured.sgL_Mov_Vid}/video`"
                    >
                      <div class="video-responsive">
                        <div class="video-sizer">
                          <div
                            class="video-image"
                            :style="{
                              backgroundImage:
                                'url(' + `${Featured.imageFileP}` + '),url(' + `${require('../../assets/images/404.png')}` + ')',
                            }"
                          ></div>
                        </div>
                      </div>
                      <div class="video-duration">
                        <span>{{ Featured.mov_VSourceTimeFormat }}</span>
                      </div>
                      <!-- </router-link> -->
                    </a>
                  </div>
                </div>
                <div class="video-info p-3">
                  <div
                    class="video-title mb-2"
                    :title="Featured.sgL_Mov_VSubject"
                  >
                    <!-- <router-link
                    v-bind:to="{name:'WatchVideo',params:{id:Featured.sgL_Mov_Vid,itemtype:'video'}}"
                  >{{Featured.sgL_Mov_VSubject}}</router-link>-->
                    <a
                      :href="`${base.evi}/videowatch/${Featured.sgL_Mov_Vid}/video`"
                      >{{ Featured.sgL_Mov_VSubject }}</a
                    >
                  </div>
                  <span class="video-user">
                    <a href="javascript:;">{{
                      Featured.sgL_Mem_DisplayName
                    }}</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <N1Vue></N1Vue>
        </div>
        <!-- 廣告 (300x600) -->
        <!-- <span class="adv-300x600 right">
          <a href>
            <img src="../../assets/images/adv/300x600.gif" alt="Advertisement" />
          </a>
        </span>-->

        <div></div>
        <!-- ./廣告 (300x600) -->
      </section>
      <!-- ./編輯精選 -->

      <!-- 我們的節目 -->
      <section
        id="programme"
        class="section-group"
        v-if="DataProgram.length > 0"
      >
        <h2 class="section-title">
          {{ $t('Video.VideoIndex.Ourshow') }}
          <router-link class="section-more" to="/programme">{{ $t('Video.VideoIndex.More') }}</router-link>
        </h2>
        <div class="section-group">
          <div class="video-row row" style="margin-left: 0px">
            <div
              class="video-card card col-4 col-lg-2"
              style="padding: 0"
              v-for="program in DataProgram"
              v-bind:key="program.id"
            >
              <!-- <router-link
                v-bind:to="{name:'WatchVideo',params:{id:program.id,itemtype:'program'}}"
              >-->
              <a :href="`${base.evi}/videowatch/${program.id}/program`">
                <div class="programme">
                  <img
                    style="width: 100%"
                    :src="`${program.sgL_LogImage}`"
                    alt
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <!-- /.我們的節目 -->
      <!-- 最新影片 -->
      <section
        id="latest-video"
        class="section-group"
        v-if="videodataVideo.length > 0"
      >
        <h2 class="section-title">
          {{ $t('Video.VideoIndex.NEW') }}
          <router-link class="section-more" to="/videolist">{{ $t('Video.VideoIndex.More') }}</router-link>
        </h2>
        <div class="video-row row" style="margin-left: 0px">
          <div
            class="video-card card"
            v-for="movie in videodataVideo"
            v-bind:key="movie.id"
            v-on:click="videoCardClick(movie.id)"
          >
            <div class="video-block">
              <div class="video-thumbnail">
                <a :href="`${base.evi}/videowatch/${movie.id}/video`">
                  <!-- <router-link v-bind:to="{name:'WatchVideo',params:{id:movie.id,itemtype:'video'}}"> -->
                  <div class="video-responsive">
                    <div class="video-sizer">
                      <div
                        class="video-image"
                        :style="{
                          backgroundImage: 'url(' + `${movie.imageFileP}` + '),url(' + `${require('../../assets/images/404.png')}` + ')',
                        }"
                      ></div>
                    </div>
                  </div>
                  <div class="video-duration">
                    <span>{{ movie.mov_VSourceTimeFormat }}</span>
                  </div>
                </a>
                <!-- </router-link> -->
              </div>
            </div>
            <div class="video-info p-3">
              <div class="video-title mb-2" :title="movie.sgL_Mov_VSubject">
                <!-- <router-link
                  v-bind:to="{name:'WatchVideo',params:{id:movie.id,itemtype:'video'}}"
                >{{movie.sgL_Mov_VSubject}}</router-link>-->
                <a :href="`${base.evi}/videowatch/${movie.id}/video`">{{
                  movie.sgL_Mov_VSubject
                }}</a>
              </div>
              <span class="video-user">
                <a href="javascript:;">{{ movie.sgL_Mem_DisplayName }}</a>
              </span>
              <span class="video-upload-date">{{
                movie.sgL_Mov_VAddTimerH
              }}</span>
            </div>
          </div>
          <!--           <div class="video-info p-3">
            <N1Vue></N1Vue>
          </div> -->
        </div>
        <div id="video_card_disp_btn" @click="showMore">
          <hr class="video_card_hrline" />
          {{ $t('Video.VideoIndex.showMore') }}
          <hr class="video_card_hrline" />
        </div>
      </section>
      <!-- /.最新影片 -->
    </div>
    <!-- /.Container -->
  </div>
</template> 
<script>
let currentPage = 2;
let limit = 12;
import bases from "../../api/httpApi/base";
import N1Vue from "../Ad/N1.vue";

export default {
  components: {
    N1Vue,
  },
  name: "videoIndex",
  data() {
    return {
      VideoData: [],
      featureList: [],
      ProgramData: [],
      floading: true,
      ss: "",
      base: null,
    };
  },
  beforeMount() {},
  mounted() {
    //this.scroll();
  },
  created() {
    this.base = bases;
    this.$store.dispatch("updateCurrentIndex", 1);
    this.GetFeatureList();
    this.getProgramData();
    this.getVideoData();
    this.count = 0;
  },
  watch: {
    VideoData(newvalue, oldvalue) {
      if (newvalue.length > 0) {
        this.floading = false;
      } else {
        this.floading = true;
      }
    },
    ProgramData(newvalue, oldvalue) {
      if (newvalue.length > 0) {
        this.floading = false;
      } else {
        this.floading = true;
      }
    },
    featureList(newvalue, oldvalue) {
      if (newvalue.length > 0) {
        this.floading = false;
      } else {
        this.floading = true;
      }
    },
  },
  methods: {
    showMore() {
      let isLoading = false;
      if (!isLoading) {
        isLoading = true;
        let param = {
          Sorting: "1",
          SGL_IsPublic: 1,
          SkipCount: (currentPage - 1) * limit,
          MaxResultCount: limit,
        };

        this.$api.VideoApi.VideoListDesk(param).then((result) => {
          //es6 语法中then里面不能使用this调用组件中的属性，只能使用箭头函数result=>
          result.data.result.items.map((item, index) => {
            this.VideoData.push(item);
          });
          currentPage++;
          isLoading = false;
        });
      }
    },
    videoCardClick(id) {
      this.$router.push({
        path: `/videowatch/${id}/video`,
      });
      //window.href = `${this.base.evi}/videowatch/${id}/video`;
    },
    async GetFeatureList() {
      let params = {
        SGL_IsShow: 1,
        SkipCount: 0,
        MaxResultCount: 4,
      };
      this.$api.VideoApi.GetExquisite(params).then((res) => {
        this.featureList = res.data.result.items;
      });
    },
    async getVideoData() {
      let param = {
        Sorting: "1",
        SkipCount: 0,
        SGL_IsPublic: 1,
        MaxResultCount: limit,
      };
      this.$api.VideoApi.VideoListDesk(param).then((result) => {
        //es6 语法中then里面不能使用this调用组件中的属性，只能使用箭头函数result=>
        this.VideoData = result.data.result.items;
      });
    },
    async getProgramData() {
      let params = { SGL_Program_Type: 0 };
      this.$api.VideoApi.GetPageProgramOrTypeDesk(params).then((result) => {
        //es6 语法中then里面不能使用this调用组件中的属性，只能使用箭头函数result=>
        this.ProgramData = result.data.result.items;
      });
    },
    scroll() {
      let isLoading = false;
      window.onscroll = () => {
        // 距离底部200px时加载一次
        let h = document.documentElement.offsetHeight;
        let t = document.documentElement.scrollTop;
        if (t == 0) {
          t = document.body.scrollTop;
        }
        let bottomOfWindow = h - t - window.innerHeight <= 350;

        if (bottomOfWindow && isLoading == false) {
          isLoading = true;
          let param = {
            Sorting: "1",
            SGL_IsPublic: 1,
            SkipCount: (currentPage - 1) * limit,
            MaxResultCount: limit,
          };

          this.$api.VideoApi.VideoListDesk(param).then((result) => {
            //es6 语法中then里面不能使用this调用组件中的属性，只能使用箭头函数result=>
            result.data.result.items.map((item, index) => {
              this.VideoData.push(item);
            });
            currentPage++;
            isLoading = false;
          });
        }
      };
    },
  },
  computed: {
    videodataFeatured() {
      return this.featureList.slice(0, 4);
    },
    DataProgram() {
      return this.ProgramData.slice(0, 6);
    },
    videodataVideo() {
      return this.VideoData;
    },
  },
};
</script>

<style scoped>
.video-card :hover {
  cursor: pointer;
}

#featured-video {
  display: flex;
  flex-direction: column;
}
.ddd {
  display: flex;
}
</style>





// WEBPACK FOOTER //
// src/components/Video/VideoIndex.vue